<script>
export default {
  props: {
    showSerch: Boolean,
    serachItemArray: Array
  },
  data() {
    const ceraterForm = this.serachItemArray || [];
    const formData = {};
    ceraterForm.forEach(o => {
      if (o.value === "" || o.value) {
        formData[o.keyName] = o.value;
      } else {
        formData[o.keyName] = undefined;
      }
    });
    return {
      formData
    };
  },
  methods: {
    onSubmit() {
      this.$emit("onSerch", this.formData);
    },
    onChange(key) {
      this.$emit("onChange", this.formData);
    }
  }
};
</script>

<template>
  <el-form :model="formData" class="demo-form-inline serachFormNew" size="small">
    <div v-for="item in serachItemArray" :key="item.keyName">
      <el-form-item v-if="item.type==='text'" :label="item.label" class="labelStyle">
        <el-input
          v-model="formData[item.keyName]"
          @change="onChange(item.keyName)"
          class="labelInput"
          clearable
          :placeholder="item.label"
        ></el-input>
      </el-form-item>
      <el-form-item v-else-if="item.type==='select'" class="labelStyle" :label="item.label">
        <el-select
          v-model="formData[item.keyName]"
          class="labelInput"
          placeholder="请选择"
          @change="onChange(item.keyName)"
          filterable
          clearable
        >
          <el-option
            v-for="child in item.children"
            :key="child.keyName"
            :label="child.label"
            :value="child.keyName"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item v-else-if="item.type==='cascader'" class="labelStyle" :label="item.label">
        <el-cascader
          v-model="formData[item.keyName]"
          class="cascaderInput"
          popper-class="serachFormCascader"
          placeholder="请选择"
          @change="onChange(item.keyName)"
          filterable
          clearable
          :options="item.children"
          :props="{ checkStrictly: true, expandTrigger: 'hover' }"
        ></el-cascader>
      </el-form-item>
      <el-form-item v-else-if="item.type==='radio'" class="radioStyle" :label="item.label">
        <el-radio-group
          v-model="formData[item.keyName]"
          class="childrenItem"
          placeholder="请选择"
          @change="onChange"
        >
          <el-radio
            v-for="child in item.children"
            :key="child.keyName"
            :label="child.keyName"
            :value="child.keyName"
          >{{child.label}}</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item v-else-if="item.type==='checkbox'" class="checkboxStyle">
        <el-checkbox
          class="childrenItem"
          v-model="formData[item.keyName]"
          @change="onChange(item.keyName)"
        >{{item.label}}</el-checkbox>
      </el-form-item>
      <el-form-item v-else-if="item.type==='number'" :label="item.label" class="labelStyle">
        <el-input-number
          v-model="formData[item.keyName]"
          @change="onChange(item.keyName)"
          class="labelInputNumber"
          clearable
          :controls="false"
          placeholder="请输入"
        ></el-input-number>
      </el-form-item>
    </div>
    <el-form-item v-if="showSerch">
      <elementButton size="mini" class="serchButton" @click="onSubmit">搜索</elementButton>
    </el-form-item>
  </el-form>
</template>

<style lang="scss">
.serachFormNew {
  //   border: 1px;
  margin: 0 1%;
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  .el-form-item--small.el-form-item {
    margin-bottom: 0;
  }
  .el-radio__input.is-checked .el-radio__inner {
    border-color: #00c1de;
    background-color: #fff;
  }

  .el-radio__inner::after {
    background-color: #00c1de;
  }

  .el-radio__input.is-checked + .el-radio__label {
    color: #00c1de;
  }

  .el-checkbox__input.is-checked + .el-checkbox__label {
    color: #00c1de;
  }

  .el-checkbox__input.is-checked .el-checkbox__inner,
  .el-checkbox__input.is-indeterminate .el-checkbox__inner {
    border-color: #00c1de;
    background-color: #00c1de;
  }
  .el-select .el-input.is-focus .el-input__inner {
    border-color: #00c1de;
  }
  .el-select-dropdown__item.hover {
    color: #00c1de;
  }
  .el-input.is-active .el-input__inner,
  .el-input__inner:focus {
    border-color: #00c1de;
  }
  .el-input.is-active .el-input__inner,
  .el-input__inner:hover {
    border-color: #00c1de;
  }

  .labelStyle {
    margin: 10px;
    width: auto;
    display: flex;
  }
  .checkboxStyle {
    margin: 10px;
    width: auto;
    display: flex;
  }
  .labelInput {
    width: 150px;
    height: 36px;
    line-height: 36px;
    .el-input__inner {
      height: 36px;
      line-height: 36px;
    }
  }
  .cascaderInput {
    width: auto;
    height: 36px;
    line-height: 36px;
    .el-input__inner {
      height: 36px;
      line-height: 36px;
    }
  }
  .labelInputNumber {
    width: 110px;
  }

  .serchButton {
    margin: 10px;
    font-size: 14px;
    
    width: 60px;
    height: 36px;
    background: rgba(0, 193, 222, 1);
    border-color: #00c1de;
    border-radius: 4px;
  }
  .radioStyle {
    margin: 10px;
    font-size: 14px;
    width: 300px;
    .childrenItem {
      min-width: 220px;
      .el-radio {
        margin-right: 10px;
      }
    }
  }
}
.el-select-dropdown__item.selected {
  color: #00c1de;
}
.serachFormCascader {
  .el-scrollbar__wrap {
    max-height: 350px;
  }
}
</style>



// WEBPACK FOOTER //
// yotta-vue-components/vision/serachFormNew.vue